var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-link"},[_c('el-tooltip',{attrs:{"content":"设置跳转的链接"}},[_c('a',{staticClass:"choice",style:({ color: _vm.color }),on:{"click":function($event){return _vm.handleSelectLink()}}},[_vm._v(" "+_vm._s(_vm.text))])]),_c('LinkModal',{ref:"LinkModal",on:{"handleSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }